module.exports = __webpack_public_path__ + "static/media/sidebar-expand.226dd8d7.svg";